import { aboutData } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-100 mb-2">关于51cg吃瓜</h2>
        <p className="text-sm text-foreground-500 mb-8 md:mb-10">了解国内领先的网红八卦与明星争议资讯聚合平台</p>
        <div className="bg-background-100 rounded-xl p-6 md:p-8 border border-background-200/60">
          <p className="text-sm md:text-base text-foreground-400 leading-relaxed">{aboutData.content}</p>
          <div className="flex flex-wrap gap-4 mt-6 pt-6 border-t border-background-200/60">
            <div className="flex items-center gap-2">
              <span className="text-lg font-bold text-primary-400">50+</span>
              <span className="text-xs text-foreground-500">日均更新篇数</span>
            </div>
            <div className="flex items-center gap-2">
              <span className="text-lg font-bold text-accent-400">100万+</span>
              <span className="text-xs text-foreground-500">活跃用户社区</span>
            </div>
            <div className="flex items-center gap-2">
              <span className="text-lg font-bold text-primary-400">24/7</span>
              <span className="text-xs text-foreground-500">全天候运营</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}